import Dialog from '@mui/material/Dialog';
import EmailVerification from '../Common/modals/EmailVerification';


export default function EmailVerificationModal({ handleClose, modalOpen, handleBackgroundModalClose,  formik, formik1, show, setShow , triggerRegister }) {
  return (
    <Dialog
      // onClose={handleClose}
      aria-labelledby="Common_modal"
      open={modalOpen}
      PaperProps={{
        sx: {
          borderRadius: '25px', 
          border: '3px solid #001c3c',
          maxWidth:"450px",
          // minWidth:"350px"

        },

      }}
    >
    <EmailVerification triggerRegister={triggerRegister} handleBackgroundModalClose={handleBackgroundModalClose} handleClose={handleClose} modalOpen={modalOpen} formik={formik} formik1={formik1} show={show} setShow={setShow} />

    </Dialog>
  );
}
